import { apiClient } from "./ApiClient";

export async function fetchInstructions(system, { action = null, man_type = null, language = null } = {}) {
  const { data } = await apiClient.get(`/instruction/manual/${system}`, {
    params: {
      ...(action && { action }),
      ...(man_type && { man_type }),
      ...(language && { language }),
    },
  });
  return data;
}

export async function fetchFAQ({ search = "", language = null } = {}) {
  const { data } = await apiClient.get("/instruction/helpdesk", {
    params: {
      ...(search && { search }),
      ...(language && { language }),
    },
  });
  return data;
}
